import { takeEvery, call, put, select } from 'redux-saga/effects'
import { SubmissionError } from 'redux-form'

import {
  updatePasswordRecovery,
  updatePasswordSet,
  errorPassword,
  PASSWORD_RECOVERY_POST,
  PASSWORD_SET_POST,
  PASSWORD_RESET_POST,
} from 'actions/password'
import { getConfigJson, updateUserData } from 'actions/general'
import { logInteraction } from 'util/log-interaction'
import needsGeneralState from 'util/needs-general-state'
import { generalStateSelector } from 'selectors/redux-selectors'

function _postPasswordRecovery({ create }, logError) {
  return function*(action) {
    try {
      logInteraction('recover password')
      const accountEndpoint = '/auth/reset'

      const values = action.payload.values

      const recoverPasswordResult = yield call(create, accountEndpoint, values)

      yield put(
        updatePasswordRecovery({
          data: recoverPasswordResult,
        })
      )

      yield call(action.payload.resolve)
    } catch (err) {
      yield call(logError, err)

      const data =
        err.status === 400 && err.responseText
          ? JSON.parse(err.responseText)
          : null
      const errorData = data.msg

      if (errorData) {
        yield call(
          action.payload.reject,
          new SubmissionError({ _error: errorData })
        )
      } else {
        yield call(action.payload.reject)
      }

      yield put(
        errorPassword({
          error: true,
          data: data,
        })
      )
    }
  }
}

const _postPasswordSetGenerator = route => ({ create }, logError) => {
  return function*(action) {
    try {
      logInteraction('set password')
      const accountEndpoint = `/auth/${route}/${action.payload.token}`

      const values = action.payload.values
      values.password_confirm = values.password

      const setPasswordResult = yield call(create, accountEndpoint, values)

      yield put(
        updatePasswordSet({
          data: setPasswordResult,
        })
      )
      yield put(
        updateUserData({
          portalUrl: setPasswordResult.returnTo,
        })
      )

      const generalState = yield select(generalStateSelector)
      if (needsGeneralState(generalState)) {
        yield put(getConfigJson())
      }

      yield call(action.payload.resolve)
    } catch (err) {
      yield call(logError, err)

      const data =
        err.status === 400 && err.responseText
          ? JSON.parse(err.responseText)
          : null
      const errorData = data.msg

      if (errorData) {
        yield call(
          action.payload.reject,
          new SubmissionError({ _error: errorData })
        )
      } else {
        yield call(action.payload.reject)
      }

      yield put(
        errorPassword({
          error: true,
          data: data,
        })
      )
    }
  }
}

export const Test = {
  _postPasswordRecovery,
  _postPasswordSetGenerator,
}

// Watchers
// ---------------------------------------------------------------------------
export function* watchPostPasswordRecovery(api, error) {
  yield takeEvery(PASSWORD_RECOVERY_POST, _postPasswordRecovery(api, error))
}

export function* watchPostPasswordSet(api, error) {
  yield takeEvery(
    PASSWORD_SET_POST,
    _postPasswordSetGenerator('set')(api, error)
  )
}

export function* watchPostPasswordReset(api, error) {
  yield takeEvery(
    PASSWORD_RESET_POST,
    _postPasswordSetGenerator('reset')(api, error)
  )
}
